// primary-slider.js

export default () => ({
    slider_top: null,
    slider_nav: null,

    active_slide_index: 0,
    autoplay: true,
    autoplay_progress: 0,

    animationFrameId: null,

    init() {
        // noinspection JSUnresolvedReference
        const slider_nav_el = this.$root.querySelector('#primary_slider_nav');
        const slidesCount = slider_nav_el.dataset.slidesCount;
        const adaptiveView = slider_nav_el.dataset.adaptiveView;

        this.slider_nav = new Swiper(slider_nav_el, {
            slidesPerView: 1,
            spaceBetween: 0,
            freeMode: false,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            breakpoints: {
                1024: {
                    slidesPerView: (slidesCount < 4) ? (adaptiveView ? slidesCount : 4) : 4
                },
            },
        });

        // noinspection JSUnresolvedReference
        const slider_top_el = this.$root.querySelector('#primary_slider_top');

        this.slider_top = new Swiper(slider_top_el, {
            slidesPerView: 1,
            grabCursor: true,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            thumbs: {
                swiper: this.slider_nav,
            },
            loop: true,
        });

        // Назначаем события ПОСЛЕ инициализации с помощью СТРЕЛОЧНЫХ функций
        // Это гарантирует, что `this` внутри обработчика будет указывать на Alpine-компонент.

        this.slider_top.on('slideChange', (swiper) => {
            // `swiper.realIndex` используется вместо `swiper.activeIndex` при включенном `loop: true`
            // т.к. Swiper создает дубликаты слайдов и activeIndex может быть больше реального кол-ва
            this.active_slide_index = swiper.realIndex;
            this.autoplay_progress = 0;
        });

        this.slider_top.on('touchStart', () => {
            this.stopAutoplay();
        });

        // Если слайдов больше одного, запускаем автопрокрутку
        if (this.slider_top.slides.length > 1) {
            slider_nav_el.classList.add('has-autoplay');
            this.startAutoplayTick();
        }
    },

    /**
     * Обрабатывает клик по навигационному элементу
     * @param {number} index - Индекс слайда для переключения
     */
    handleNavClick(index) {
        this.stopAutoplay();
        this.slider_top.slideToLoop(index); // Используем slideToLoop т.к. основной слайдер зациклен
    },

    tick() {
        if (!this.autoplay) {
            return; // Просто выходим, если автопрокрутка остановлена
        }

        // Увеличиваем прогресс. 0.4 - это скорость, подберите нужное значение
        this.autoplay_progress += 0.4;

        if (this.autoplay_progress >= 100) {
            // Просто переключаем на следующий. Swiper с `loop: true` сам разберется с переходом с_последнего на первый.
            this.slider_top.slideNext();
            // Сброс прогресса произойдет в событии 'slideChange'
        }

        // Запрашиваем следующий кадр анимации
        this.animationFrameId = requestAnimationFrame(this.tick.bind(this));
    },

    startAutoplayTick() {
        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
        }
        this.animationFrameId = requestAnimationFrame(this.tick.bind(this));
    },

    stopAutoplay() {
        if (this.autoplay) {
            this.autoplay = false;
            // noinspection JSUnresolvedReference
            const slider_nav_el = this.$root.querySelector('#primary_slider_nav');
            slider_nav_el.classList.remove('has-autoplay');

            if (this.animationFrameId) {
                cancelAnimationFrame(this.animationFrameId);
                this.animationFrameId = null; // Обнуляем для чистоты
            }
        }
    }
});